import React, { useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { solicitarRecuperacionPassword } from "../../services/api";
import "./forgotPass.css";

export default function ForgotPass() {
  const [correo, setCorreo] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await solicitarRecuperacionPassword({ correo: correo.trim() });
      toast.success(res?.mensaje || "Si el correo existe, se enviará un enlace de recuperación.");
      setCorreo("");
    } catch (err) {
      toast.error(
        err?.response?.data?.mensaje ||
        err?.message ||
        "No se pudo procesar la solicitud."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth container">
      <div className="auth-card">
        <h1 className="auth-title">Recuperar cuenta</h1>
        <p className="auth-subtitle">
          Ingresa tu correo y se enviará un enlace para continuar con el registro de una nueva contraseña.
        </p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-label">
            Correo
            <input
              className="auth-input"
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              placeholder="tucorreo@dominio.com"
            />
          </label>

          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>

        <p className="auth-alt">
          <Link to="/login">Volver a iniciar sesión</Link>
        </p>
      </div>
    </div>
  );
}